import { render, staticRenderFns } from "./NumPerNum.vue?vue&type=template&id=ae121182"
import script from "./NumPerNum.vue?vue&type=script&lang=js"
export * from "./NumPerNum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports